export default __webpack_public_path__ + "static/media/mc_cv_2.c6e47514.jpg";